import React from "react";
import Button from "../../components/common/Button";
import { useMediaQuery } from "react-responsive";
import { getMainInfoByName } from "../../backend/info/mainInfo";
import formatPhoneNumber from "../../utils/formatNumber";

const Hiring = () => {
  const isSingle = useMediaQuery({ query: `(max-width: 1420px)` });
  const isImageMovedLeft = useMediaQuery({ query: `(max-width: 1750px)` });
  const isImageSmall = useMediaQuery({ query: `(max-width: 1600px)` });
  const isImageMoved = useMediaQuery({ query: `(max-width: 1220px)` });
  const isMedium = useMediaQuery({ query: `(max-width: 1070px)` });
  const isImageBelow = useMediaQuery({ query: `(max-width: 760px)` });
  const isImageTiny = useMediaQuery({ query: `(max-width: 800px)` });
  const isButtonFullLength = useMediaQuery({ query: `(max-width: 700px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 450px)` });
  return (
    <div style={styles.hiringWrapper}>
      <div style={styles.hiringContainer}>
        <div
          style={{
            ...styles.hiringColumn,
            paddingTop: isMedium ? "2rem" : "4rem",
            paddingBottom: "4rem",
            gap: isSmall ? "1rem" : isMedium ? "2rem" : "4rem",
          }}
        >
          <div style={styles.headerContainer}>
            <h2
              style={{
                ...styles.mainHeader,
                marginBottom: isMedium ? "" : "",
                fontSize: isMedium ? "min(4rem,9vw)" : "min(5rem,10vw)",
                lineHeight: isMedium ? "min(4rem,10vw)" : "min(5rem,10vw)",
              }}
            >
              Приймаємо фахівців
              <br />
              на бойові та небойові{isImageBelow ? " " : <br />}посади
            </h2>
          </div>
          <p
            style={{
              ...styles.description,
              }}
          >
            Заповніть форму на сайті, або, якщо у Вас є запитання,{isImageBelow ? " " : <br />}
            зателефонуйте в наш рекрутинговий відділ
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              marginTop: isSmall ? "1rem" : isSingle ? "2rem" : "0rem",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: isSingle ? "column" : "row",
                gap: isSmall ? "1rem" : "2rem",
              }}
            >
              <Button
                text={getMainInfoByName("recruitmentPhone")}
                external_link={formatPhoneNumber(getMainInfoByName("recruitmentPhone"))}
                border="3px solid var(--white)"
                hoverBorder="3px solid var(--black)"
                textColor="var(--white)"
                hoverTextColor="var(--black)"
                hoverBackgroundColor="white"
                fontWeight="bold"
                fontSize={isButtonFullLength ? "8vw" : "min(2.5rem, 6vw)"}
                lineHeight="min(6rem,15vw)"
                padding="1rem 1rem"
                iconPath="/assets/icons/tel.svg"
                iconProps={{
                  width: "min(3rem,10vw)",
                  height: "min(3rem,10vw)",
                  marginRight: "1rem",
                }}
                iconColor="var(--white)"
                hoverIconColor="var(--black)"
                containerProps={isButtonFullLength ? { width: "var(--main-container-width)" } : {}}
              />
              <Button
                text={"Замовити дзвінок"}
                external_link={getMainInfoByName("anketaLink")}
                textColor="var(--white)"
                border="3px solid var(--white)"
                hoverBackgroundColor="white"
                hoverBorder="3px solid var(--black)"
                hoverTextColor="var(--black)"
                fontSize={isButtonFullLength ? "8vw" : "min(2.5rem, 6vw)"}
                lineHeight="min(6rem,15vw)"
                padding="1rem 1rem"
                fontWeight="bold"
                containerProps={isButtonFullLength ? { width: "var(--main-container-width)" } : {}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  hiringWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background: "url('assets/landing/с1.avif') top left no-repeat",
    backgroundSize: "cover",
    alignItems: "center",
    overflowX: "clip",
    overflowY: "visible",
  },
  hiringContainer: {
    display: "flex",
    flexDirection: "row",
    width: "var(--main-container-width)",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  hiringColumn: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignSelf: "flex-start",
    maxWidth: "var(--main-container-width)",
    flexShrink: "0",
    minHeight: "40rem",
    gap: "4rem",
  },
  headerContainer: {
    display: "flex",
    flexDirection: "column",
  },
  mainHeader: {
    fontSize: "min(5rem,10vw)",
    fontWeight: "bold",
    color: "var(--white)",
  },
  subHeader: {
    fontSize: "min(2.5rem,6vw)",
    color: "var(--black)",
  },
  description: {
    fontSize: "min(1.5rem,5vw)",
    color: "var(--white)",
  },
  buttonRow: {
    display: "flex",
    flexDirection: "row",
    gap: "4rem",
  },

  imageContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    position: "relative",
  },
};

export default Hiring;
